import sx from 'utils/createSx';

export default sx({
  container: {
    minHeight: '100vh',
    backgroundColor: '#f9f9f9',
    p: 3,
  },
  gridContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 3,
  },
  card: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    p: 2,
    mb: 2,
  },
  newAddressButton: {
    display: 'flex',
    alignItems: 'center',
    mt: 2,
  },
  shippingSectionContainer: {
    mt: 8, // Adds more space between sections
  },
  subtitle: {
    fontWeight: 'bold',
    mb: 2,
  },
  addressText: {
    fontWeight: 'bold',
    mb: 1,
  },
  addressDetails: {
    color: '#757575',
  },
  shippingOptionContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  shippingOptionTitle: {
    fontWeight: 'bold',
  },
  shippingOptionDetails: {
    color: '#757575',
  },
  shippingOptionPrice: {
    color: '#4caf50',
    fontWeight: 'bold',
  },
  disclaimer: {
    fontSize: '0.8rem',
    color: '#757575',
    mt: 1,
  },
  summaryCard: {
    borderRadius: 4,
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    p: 2,
  },
  productText: {
    fontWeight: 'bold',
    mb: 1,
  },
  quantityText: {
    color: '#757575',
    mb: 2,
  },
  summaryContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    mb: 1,
  },
  summaryText: {
    fontWeight: 'bold',
  },
  summaryValue: {
    fontWeight: 'bold',
  },
  totalText: {
    fontWeight: 'bold',
    color: '#000',
  },
  totalValue: {
    fontWeight: 'bold',
    color: '#4caf50',
  },
  advanceButton: {
    mt: 2,
    width: '100%',
    backgroundColor: '#4caf50',
    '&:hover': {
      backgroundColor: '#388e3c',
    },
  },
});
